import { useToast } from '@chakra-ui/react';
import { useCallback, useMemo } from 'react';

import { trpc } from '../config/trpc';

export type EmailRequestProps = { requestId: number; type: 'Booked' | 'Update' };

export const useEmailRequest = ({ requestId, type }: EmailRequestProps) => {
  const { mutateAsync: sendCustomerBookedQuote, isLoading: isBookedQuoteSending } =
    trpc.sendCustomerBookedQuote.useMutation();
  const { mutateAsync: sendCustomerQuoteUpdate, isLoading: isQuoteUpdateSending } =
    trpc.sendCustomerQuoteUpdate.useMutation();

  const toast = useToast();

  const sendEmail = useMemo(
    () => (type === 'Update' ? sendCustomerQuoteUpdate : sendCustomerBookedQuote),
    [sendCustomerBookedQuote, sendCustomerQuoteUpdate, type],
  );

  const handleEmailRequest = useCallback(async () => {
    try {
      await sendEmail({ requestId });
      toast({
        title: 'Success',
        description: 'An email has been sent to you successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: 'Something went wrong',
        description: error?.message,
        status: 'error',
        duration: 6000,
        isClosable: true,
      });
    }
  }, [requestId, sendEmail, toast]);

  return { handleEmailRequest, isLoading: isBookedQuoteSending || isQuoteUpdateSending };
};
